module.exports = __webpack_public_path__ + "img/Anniversary35B.b15dceb9.png";